import React from 'react';
import { simpleIconPropsTypes } from '../propTypes';
import logoFull from '../../assests/advantage-logo.png';
import logoIcon from '../../assests/dvantage-icon.svg';

export const ColoredLogoSvg = (props) => {
  const { height, short = false } = props;
  const sz = height || 44;

  if (short) {
    return (
      <img
        src={logoIcon}
        alt="Advantage icon"
        width={sz}
        height={sz}
        style={{ display: 'block', flexShrink: 0, overflow: 'visible' }}
      />
    );
  }

  return (
    <img
      src={logoFull}
      alt="Advantage"
      height={sz}
      style={{ display: 'block', width: 'auto', overflow: 'visible' }}
    />
  );
};

ColoredLogoSvg.propTypes = simpleIconPropsTypes;
